import React from 'react';
import PropTypes from 'prop-types';
import { Spacer, Visible } from '@tfecom-thermofisher/react-komodo-design';

import { DetailRow } from 'src/components';
import { SummarySectionTitle } from 'src/components/OligoDNA/components/Summary/components';

import messages from '../../messages';

const FileDetailsComponent = ({ file, showTitle, onEditClick }) => {
  const { totalPlates, totalOligos, totalBases } = file.additionalData || {};

  return (
    <>
      <Visible when={showTitle}>
        <SummarySectionTitle
          titleMessage={messages.plateTemplate}
          onEditClick={onEditClick}
        />
        <Spacer bottom={8} />
      </Visible>
      <DetailRow
        label={messages.fileName}
        value={file.nameWithoutExtension}
        dots
      />
      <Spacer bottom={8} />
      <DetailRow label={messages.totalPlates} value={totalPlates} dots />
      <Spacer bottom={8} />
      <DetailRow label={messages.totalOligos} value={totalOligos} dots />
      <Spacer bottom={8} />
      <DetailRow label={messages.totalBases} value={totalBases} dots />
    </>
  );
};

FileDetailsComponent.propTypes = {
  file: PropTypes.object.isRequired,
  showTitle: PropTypes.bool,
  onEditClick: PropTypes.func,
};

export default FileDetailsComponent;
